import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { AboutSection } from "@/components/AboutSection";
import { ProductsOverview } from "@/components/ProductsOverview";
import { UseCases } from "@/components/UseCases";
import { WhyDiamondDomes } from "@/components/WhyDiamondDomes";
import { Mission } from "@/components/Mission";
import { Footer } from "@/components/Footer";
import { SEOHead, seoConfig } from "@/components/SEOHead";

const Index = () => {
  const itemListStructuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Diamond Domes kupoler",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Panoramakupoler",
        url: "https://www.diamonddomes.se/panoramakupoler",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Biokeramiska kupoler",
        url: "https://www.diamonddomes.se/biokeramiska-domes",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Nova Domes",
        url: "https://www.diamonddomes.se/nova-domes",
      },
    ],
  };

  return (
    <div className="min-h-screen">
      <SEOHead {...seoConfig.home} structuredData={itemListStructuredData} />
      <Navigation />
      <main>
        <Hero />
        <AboutSection />
        <ProductsOverview />
        <UseCases />
        <WhyDiamondDomes />
        <Mission />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
